var _defs, _circle, _circle2, _circle3, _circle4, _circle5, _g, _rect, _circle6, _rect2, _circle7, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect0, _line, _circle8, _circle9, _path, _rect1, _rect10, _rect11, _path2, _g2, _circle0, _path3, _circle1, _rect12, _rect13, _path4, _g3, _circle10, _circle11, _path5, _rect14, _rect15, _rect16, _rect17, _path6, _g4, _circle12, _circle13, _path7, _rect18, _rect19, _line2, _circle14, _circle15, _path8, _rect20, _rect21, _circle16;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgFeatureCollaboration = (_ref, ref) => {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 480,
    height: 360,
    viewBox: "0 0 480 360",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "card",
    x1: 0,
    y1: 0,
    x2: 0.4,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F1F4FC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gold",
    x1: 0,
    y1: 0,
    x2: 0,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#FFC658"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBB024"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ribbon",
    x1: 0,
    y1: 0,
    x2: 0,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#FBB024"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B06A00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hdr",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2B4CC0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4A79F0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "plat",
    x1: 0,
    y1: 0,
    x2: 0.4,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#5A82F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B4CC0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "platRim",
    x1: 0,
    y1: 0,
    x2: 0,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#233F8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16265A"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "ds",
    x: "-40%",
    y: "-40%",
    width: "180%",
    height: "180%"
  }, /*#__PURE__*/React.createElement("feDropShadow", {
    dx: 0,
    dy: 7,
    stdDeviation: 9,
    floodColor: "#141C3A",
    floodOpacity: 0.22
  })), /*#__PURE__*/React.createElement("filter", {
    id: "dsm",
    x: "-60%",
    y: "-60%",
    width: "220%",
    height: "220%"
  }, /*#__PURE__*/React.createElement("feDropShadow", {
    dx: 0,
    dy: 4,
    stdDeviation: 5,
    floodColor: "#141C3A",
    floodOpacity: 0.2
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 70,
    r: 4,
    fill: "#FBB024",
    opacity: 0.8
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 430,
    cy: 300,
    r: 4,
    fill: "#7FCACD",
    opacity: 0.7
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 44,
    cy: 260,
    r: 3,
    fill: "#6E93F4",
    opacity: 0.5
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 452,
    cy: 90,
    r: 3.5,
    fill: "#F8694A",
    opacity: 0.6
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 410,
    cy: 60,
    r: 7,
    fill: "none",
    stroke: "#FBB024",
    strokeWidth: 2.4,
    opacity: 0.55
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#ds)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 146,
    y: 48,
    width: 196,
    height: 252,
    rx: 14,
    fill: "#C9D2EA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 150,
    y: 44,
    width: 196,
    height: 252,
    rx: 14,
    fill: "url(#card)"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 168,
    y: 60,
    width: 160,
    height: 26,
    rx: 7,
    fill: "url(#hdr)"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 183,
    cy: 73,
    r: 7,
    fill: "#FFFFFF",
    opacity: 0.92
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 198,
    y: 69,
    width: 54,
    height: 7,
    rx: 3.5,
    fill: "#FFFFFF"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 314,
    cy: 73,
    r: 4.5,
    fill: "#FBB024"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 168,
    y: 106,
    width: 160,
    height: 6,
    rx: 3,
    fill: "#D9DEEE"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 168,
    y: 122,
    width: 138,
    height: 6,
    rx: 3,
    fill: "#D9DEEE"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 163,
    y: 137,
    width: 170,
    height: 22,
    rx: 6,
    fill: "#FFF1D2"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 168,
    y: 143,
    width: 4,
    height: 12,
    rx: 2,
    fill: "#FBB024"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 180,
    y: 144,
    width: 116,
    height: 6,
    rx: 3,
    fill: "#C67A00"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 302,
    y: 138,
    width: 2.6,
    height: 16,
    rx: 1.3,
    fill: "#3A68DF"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 168,
    y: 174,
    width: 150,
    height: 6,
    rx: 3,
    fill: "#D9DEEE"
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 168,
    y: 190,
    width: 120,
    height: 6,
    rx: 3,
    fill: "#D9DEEE"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 168,
    y1: 212,
    x2: 328,
    y2: 212,
    stroke: "#EAEDF6",
    strokeWidth: 2
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 180,
    cy: 240,
    r: 11,
    fill: "#3A68DF"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 180,
    cy: 236.92,
    r: 3.74,
    fill: "#FFFFFF",
    opacity: 0.95
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 173.18 247.26 a 6.82 6.050000000000001 0 0 1 13.64 0",
    fill: "#FFFFFF",
    opacity: 0.95
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    x: 198,
    y: 234,
    width: 70,
    height: 6,
    rx: 3,
    fill: "#C3CADE"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 198,
    y: 246,
    width: 44,
    height: 5,
    rx: 2.5,
    fill: "#E4E7F2"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 168,
    y: 260,
    width: 160,
    height: 24,
    rx: 7,
    fill: "#F5F7FD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M 178 278 q 6 -13 11 -3 q 4 8 9 -2 q 4 -8 9 2",
    fill: "none",
    stroke: "#20305B",
    strokeWidth: 2.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#dsm)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 312,
    y: 132,
    width: 70,
    height: 34,
    rx: 10,
    fill: "#FFFFFF"
  }))), _circle0 || (_circle0 = /*#__PURE__*/React.createElement("circle", {
    cx: 330,
    cy: 149,
    r: 11,
    fill: "#FBB024"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M 322 157 L 335 144 l 3 3 L 325 160 Z",
    fill: "#FFFFFF"
  })), _circle1 || (_circle1 = /*#__PURE__*/React.createElement("circle", {
    cx: 322.5,
    cy: 158.5,
    r: 1.6,
    fill: "#FFFFFF"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 348,
    y: 144,
    width: 24,
    height: 6,
    rx: 3,
    fill: "#C3CADE"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 348,
    y: 154,
    width: 16,
    height: 5,
    rx: 2.5,
    fill: "#E4E7F2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M 144 176 l 22 20 l -2 -22 Z",
    fill: "#FFFFFF",
    filter: "url(#dsm)"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#ds)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 120,
    width: 128,
    height: 66,
    rx: 14,
    fill: "#C9D2EA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 116,
    width: 128,
    height: 66,
    rx: 14,
    fill: "url(#card)"
  }))), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 62,
    cy: 140,
    r: 12,
    fill: "#43979B"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 62,
    cy: 136.64,
    r: 4.08,
    fill: "#FFFFFF",
    opacity: 0.95
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M 54.56 147.92 a 7.4399999999999995 6.6000000000000005 0 0 1 14.879999999999999 0",
    fill: "#FFFFFF",
    opacity: 0.95
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 82,
    y: 133,
    width: 66,
    height: 6,
    rx: 3,
    fill: "#C3CADE"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 82,
    y: 145,
    width: 44,
    height: 6,
    rx: 3,
    fill: "#E4E7F2"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 162,
    width: 96,
    height: 7,
    rx: 3.5,
    fill: "#E4F4F5"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 162,
    width: 40,
    height: 7,
    rx: 3.5,
    fill: "#43979B"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M 314 222 l -22 -16 l 20 -2 Z",
    fill: "#FFFFFF",
    filter: "url(#dsm)"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#ds)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 292,
    y: 214,
    width: 148,
    height: 96,
    rx: 14,
    fill: "#C9D2EA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 296,
    y: 210,
    width: 148,
    height: 96,
    rx: 14,
    fill: "url(#card)"
  }))), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 318,
    cy: 234,
    r: 12,
    fill: "#3A68DF"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 318,
    cy: 230.64,
    r: 4.08,
    fill: "#FFFFFF",
    opacity: 0.95
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M 310.56 241.92 a 7.4399999999999995 6.6000000000000005 0 0 1 14.879999999999999 0",
    fill: "#FFFFFF",
    opacity: 0.95
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 338,
    y: 227,
    width: 78,
    height: 6,
    rx: 3,
    fill: "#C3CADE"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 338,
    y: 239,
    width: 52,
    height: 6,
    rx: 3,
    fill: "#E4E7F2"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 318,
    y1: 254,
    x2: 318,
    y2: 280,
    stroke: "#EAEDF6",
    strokeWidth: 2
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 336,
    cy: 280,
    r: 9,
    fill: "#4BB970"
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: 336,
    cy: 277.48,
    r: 3.06,
    fill: "#FFFFFF",
    opacity: 0.95
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M 330.42 285.94 a 5.58 4.95 0 0 1 11.16 0",
    fill: "#FFFFFF",
    opacity: 0.95
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 352,
    y: 274,
    width: 60,
    height: 6,
    rx: 3,
    fill: "#C3CADE"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 352,
    y: 285,
    width: 40,
    height: 5,
    rx: 2.5,
    fill: "#E4E7F2"
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    cx: 438,
    cy: 216,
    r: 7,
    fill: "#F8694A",
    stroke: "#FFFFFF",
    strokeWidth: 2
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgFeatureCollaboration);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/feature_collaboration.f0b3bb667d81422b4e49a9be2e97c846.svg";